<template>
    <v-card
        :color="'rgba(73, 200, 79, .1)'"
        elevation="0"
        class="mb-4 px-2"
        width="100%"
    >
        <v-card-title>
            <v-row>
                <v-col class="pa-0">
                    <span class="onlineStatusLabel">Caching tickets for offline mode</span>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="text-center px-0 py-1">
            <v-progress-circular
                :value="cacheOfflineDataProgress"
                :size="60"
                color="#49C84F"
                :rotate="90"
            >
                <span class="progress-text">
                    {{ cacheOfflineDataProgress }}%
                </span>
            </v-progress-circular>
            <v-spacer />
        </v-card-text>
    </v-card>
</template>
<script>

export default {
    computed: {
        cacheOfflineDataProgress() {
            return this.$store.getters.cachingOfflineDataProgress;
        },
        connectedSystem() {
            return this.$store.getters.systemVariables.find(sysVar => sysVar.name === 'SYSID').value;
        },
        allSystems() {
            const allSystems = this.$store.getters.systemVariables
                .filter(sysVar => /^SYSID_.$/.test(sysVar.name))
                .map(systemSysVar => {
                    return {
                        serverName: systemSysVar.name.slice(-1),
                        serverDomain: systemSysVar.value,
                    };
                });

            return allSystems;
        },

    },
};
</script>
<style scoped>
.onlineStatusLabel {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.001em;
    text-align: left;
}
.onlineSwitch {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.001em;
    text-align: left;
}
.onlineSinceText {
    color: #35383F;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.004em;
    text-align: left;
}
.progress-text {
    color:#35383F;
    font-weight: bold;
}
</style>
